import { render, staticRenderFns } from "./GoodsLinkCopyDialog.vue?vue&type=template&id=9a2adf40&scoped=true&"
import script from "./GoodsLinkCopyDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsLinkCopyDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsLinkCopyDialog.vue?vue&type=style&index=0&id=9a2adf40&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2adf40",
  null
  
)

export default component.exports